// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  npc: __t.u64(),
  subjectKind: __t.u8().name("subject_kind"),
  subjectId: __t.u64().name("subject_id"),
  grudge: __t.u8(),
  debt: __t.u8(),
  fear: __t.u8(),
  respect: __t.u8(),
  familiarity: __t.u8(),
  knowledge: __t.array(__t.u16()),
  lastMovedWeek: __t.u64().name("last_moved_week"),
  tension: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
